<template>
    <v-dialog v-model="model" max-width="500">
        <v-card>

            <toolbar-page title="Preview for">

            </toolbar-page>

            <v-card-text class="pt-4">

                <v-container fluid fill-height class="pa-0 pb-2">
                    <v-row dense>
                        <v-col cols="12">
                            <v-select
                                v-model="subPanelModel"
                                :items="subPanels"
                                item-text="name"
                                item-value="id"
                                label="Select sub panel"
                                return-object
                                hide-details
                                @change="subPanelChanged"
                            ></v-select>
                        </v-col>

                        <v-col cols="12">
                            <v-select
                                v-model="localeModel"
                                :items="locales"
                                item-text="code"
                                item-value="id"
                                hide-details
                                label="Select locale"
                                return-object
                                @change="localeChanged"
                            ></v-select>
                        </v-col>

                        <v-col cols="12" class="mt-4">

                            <v-btn color="primary" :loading="loading" @click="testEntryLinkOpen">Start</v-btn>

                            <v-scale-transition>
                                <v-btn text v-show="showRememberButton" @click="rememberSettings">Remember locale?</v-btn>
                            </v-scale-transition>

                        </v-col>

                    </v-row>
                </v-container>
            </v-card-text>
        </v-card>
    </v-dialog>


</template>

<script>

import ToolbarPage from "../../../../components/UI/ToolbarPage";
import {mapActions, mapState} from "vuex";
import {preferredLocale} from "../../../../components/mixins/preferredLocaleMixin";

export default {

    mixins: [preferredLocale],

    components: {ToolbarPage},

    props: {
        value: {
            required: true,
            type: Boolean,
        },
        project: {
            required: true,
            type: Object,
        }
    },

    computed: {

        ...mapState('SubPanels', [
            'subPanels'
        ]),

        model: {
            get() {
                return this.value;
            },

            set(value) {
                this.$emit('input', value);
            }
        },

        locales() {

            if (!this.subPanelModel) return [];

            const subPanel = this.subPanels.find(subPanel => {
                return subPanel.id === this.subPanelModel.id;
            });

            if (!subPanel) return [];

            return subPanel.locales;
        },
    },

    watch: {
        value(enabled) {
            if (enabled) {
                this.loadSubPanels()
                    .then(() => {

                        if (this.subPanels.length > 0) {

                            // Preview links always use first sub panel
                            this.subPanelModel = this.subPanels[0];
                            this.localeModel = this.findPreferredLocale(this.subPanelModel);
                        }
                    })
                    .catch((error) => {

                        console.error(error);

                        Bus.$emit('flash-message', {
                            type: 'error',
                            message: 'OOPS. We failed to required data! Please try again'
                        });
                    });

            }
        }
    },

    data() {
        return {
            subPanelModel: null,
            localeModel: null,
            showRememberButton: false,
            loading: false,
        }
    },

    methods: {

        ...mapActions('SubPanels', [
            'loadSubPanels'
        ]),

        localeChanged() {
            this.showRememberButton = true;
        },

        subPanelChanged(subPanel) {
            this.localeModel = this.findPreferredLocale(subPanel);
        },

        rememberSettings() {
            this.showRememberButton = false;
            this.setPreferredLocale(this.localeModel.code);
        },

        testEntryLinkOpen() {

            this.loading = true;

            this.$store.dispatch('ProjectManager/getEntryTestLink', {
                projectId: this.project.id,
                subPanelId: this.subPanelModel.id,
                locale: this.localeModel.code,
            })
                .then((data) => {
                    this.$emit('input', false);
                    window.open(data.testLink, '_blank').focus();
                })
                .catch(() => {
                    Bus.$emit('flash-message', {type: 'error', message: 'OOPS. We failed to produce test link!'});
                })
                .finally(() => {
                    this.loading = false;
                });

        }
    }
}
</script>
